import { ConsentDecorator } from "../../../components/RoutesDecorator/ConsentDecorator";
import { ActionsList, AdministrationLayout } from "../../../containers";
import "./UserActionsPage.less";

const UserActionsPage: React.FC = () => {
    return (
        <ConsentDecorator>
            <AdministrationLayout title="Журнал действий">
                <ActionsList className="qpd-rstr-event-log-page"/>
            </AdministrationLayout>
        </ConsentDecorator>
    )
        
}

export default UserActionsPage;